import React from 'react';
import type { NumberLineItem } from '../../../../transformers/zod-schemas';
import { useSound } from '../../../sounds';

type CounterDef = NonNullable<NumberLineItem['counter']>;

export interface CounterControlsProps {
  counter: CounterDef;
  count: number;
  onDecrement: () => void;
  onIncrement: () => void;
}

export const CounterControls: React.FC<CounterControlsProps> = ({
  counter, count, onDecrement, onIncrement,
}) => {
  const playSound = useSound();
  return (
  <div className="number-line-counter" aria-label={counter.name ?? 'Counter'}>
    <div className="number-line-counter-controls">
      <button
        type="button"
        className="number-line-counter-btn"
        aria-label="Decrease"
        disabled={count <= counter.min}
        onClick={() => { playSound('counter-step'); onDecrement(); }}
      >
        −
      </button>
      <span className="number-line-counter-value" data-testid="counter-value">
        {count}
      </span>
      <button
        type="button"
        className="number-line-counter-btn"
        aria-label="Increase"
        disabled={count >= counter.max}
        onClick={() => { playSound('counter-step'); onIncrement(); }}
      >
        +
      </button>
    </div>
    {counter.name && (
      <span className="number-line-counter-label">{counter.name}</span>
    )}
  </div>
  );
};
